import React from "react";
import { connect } from "react-redux";
import { I18n } from "@aws-amplify/core";
import { get, forEach, filter } from "lodash";

import Events from "./Events";
import { setBreadcrumb } from "../../actions/common";
import { fetchEventGroups, fetchEvents } from "../../actions/events";
import { findEvent } from "../../utils/eventGroups";
import { eventGroups, allEvents } from "../../constants/common";

const EventsContainer = (props) => {
  const { dispatch, dialog = false, language } = props;
  const [selectedEvent, setSelectedEvent] = React.useState();
  const [selectedEventIdDialog, setSelectedEventIdDialog] = React.useState();

  const section = get(props, ["match", "params", "tab2"]) || eventGroups;
  const selectedEventId =
    get(props, ["match", "params", "selected"]) || selectedEventIdDialog;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    if (selectedEventId !== get(selectedEvent, ["id"])) {
      if (!selectedEventId) {
        setSelectedEvent();
      } else if (section === eventGroups) {
        setSelectedEvent(
          findEvent(get(props, ["events", eventGroups]), selectedEventId)
        );
      } else if (section === allEvents) {
        forEach(get(props, ["events", allEvents]), (e) => {
          if (get(e, ["id"]) === selectedEventId) {
            setSelectedEvent(e);
          }
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  });

  // Automatically load child event groups when dialog
  React.useEffect(() => {
    if (
      dialog &&
      section === eventGroups &&
      !get(props, ["events", "fetchingChild"]) &&
      get(props, ["events", section, 0]) &&
      !get(props, ["events", section, 0, "childEventGroups"])
    ) {
      loadChildEventGroups(get(props, ["events", section, 0, "id"]));
    }
  });

  React.useEffect(() => {
    if (!dialog) dispatch(setBreadcrumb([{ name: I18n.get("topbar_events") }]));
    if (props.eventGroupId) {
      dispatch(fetchEventGroups(1, 0, [props.eventGroupId]));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadData = (limit, offset) => {
    if (section === eventGroups) {
      dispatch(fetchEventGroups(limit, offset * limit, null, [null]));
    } else if (section === allEvents) {
      dispatch(fetchEvents(limit, offset * limit, null, [null]));
    }
  };

  const loadChildEventGroups = (parentId) => {
    dispatch(fetchEventGroups(2147483647, 0, null, [parentId]));
  };

  const selectEvent = (e) => {
    if (dialog) {
      setSelectedEventIdDialog(get(e, ["id"]));
    } else {
      props.history.push(
        `/events/${section}/${get(e, ["id"])}?${new URLSearchParams(
          window.location.search
        ).toString()}`
      );
    }
  };

  const goToEventGroup = (id) => {
    let eventGroup = get(
      filter(
        get(props, ["events", eventGroups]),
        (item) => get(item, ["id"]) === id
      ),
      [0]
    );
    if (eventGroup) {
      setSelectedEvent(eventGroup);
      if (!dialog) {
        props.history.push(
          `/events/eventGroups/${id}?${new URLSearchParams(
            window.location.search
          ).toString()}`
        );
      } else {
        setSelectedEventIdDialog(id);
      }
    } else {
      dispatch(fetchEventGroups(1, 0, [id]));
      props.history.push(
        `/events/eventGroups/${id}?${new URLSearchParams(
          window.location.search
        ).toString()}`
      );
    }
  };

  const closeDetailsPanel = () => {
    setSelectedEvent();
    setSelectedEventIdDialog();
    if (!dialog) {
      props.history.push(
        `/events/eventGroups?${new URLSearchParams(
          window.location.search
        ).toString()}`
      );
    }
  };

  return (
    <Events
      events={get(props, ["events", section])}
      total={get(props, ["events", "total"])}
      isFetching={get(props, ["events", "isFetching"])}
      isFetchingChild={get(props, ["events", "fetchingChild"])}
      dialog={dialog}
      loadData={loadData}
      selectEvent={selectEvent}
      selectedEvent={selectedEvent}
      loadChildEventGroups={loadChildEventGroups}
      closeDetailsPanel={closeDetailsPanel}
      goToEventGroup={goToEventGroup}
      section={section}
      selectedEventId={selectedEventId}
      language={language}
      displayOptions={{
        tableHeight: "calc(100vh - 250px)",
      }}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    events: state.events,
    language: state.user.language,
  };
};

export default connect(mapStateToProps)(EventsContainer);
